import React, { memo, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useSlate } from "slate-react";

export interface IProps {
  children: React.ReactNode;
  direction: "undos" | "redos";
  hasChanges: boolean;
}

const HistoryButton: React.FC<IProps> = memo(
  ({ children, direction, hasChanges }) => {
    const editor = useSlate();
    const isActive = hasChanges && editor.history[direction].length;

    const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      if (direction === "undos") {
        editor.undo();
      } else {
        editor.redo();
      }
    };

    return (
      <button
        className="editor-toolbar__button editor-toolbar__button--history"
        onMouseDown={handleMouseDown}
        disabled={!isActive}
      >
        {children}
      </button>
    );
  },
);

export { HistoryButton };
